import { render, staticRenderFns } from "./BubbleIcon.vue?vue&type=template&id=4a53e74c&scoped=true&"
import script from "./BubbleIcon.vue?vue&type=script&lang=js&"
export * from "./BubbleIcon.vue?vue&type=script&lang=js&"
import style0 from "./BubbleIcon.vue?vue&type=style&index=0&id=4a53e74c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a53e74c",
  null
  
)

export default component.exports